"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveStatusSelector = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const active_status_selector_styles_1 = require("./active-status-selector.styles");
const localization_1 = require("../../../../../../localization");
const ActiveStatusSelector = ({ onOptionChange, selected }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const options = [
        { label: t({ key: 'ACTIVE' }), value: 'true' },
        { label: t({ key: 'INACTIVE' }), value: 'false' },
    ];
    const handleChange = (event) => {
        onOptionChange(event.target.value);
    };
    return (react_1.default.createElement(active_status_selector_styles_1.StyledSelect, { onChange: handleChange, value: selected, fullWidth: true, MenuProps: {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
        } }, options.map(({ value, label }) => (react_1.default.createElement(ui_components_1.MenuItem, { key: value, value: value }, label)))));
};
exports.ActiveStatusSelector = ActiveStatusSelector;
exports.default = exports.ActiveStatusSelector;
